// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4sjcv","colMin":"styles_colMin__2F9dE"};